module.exports = __webpack_public_path__ + "img/313.cf65967a.png";